<template>
  <div class="bb-notifications-bar-main-reject">
    <div class="bb-notifications-bar-main-reject__description bb-notifications-bar-main-reject__description_bold">
      Reason
    </div>
    <div class="bb-notifications-bar-main-reject__description">
      {{item.rejectComment}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotificationsBarMainReject',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";

  .bb-notifications-bar-main-reject {
    display: grid;
    grid-gap: 7px 0;
    margin: 5px 0 0 0;

    &__description {
      font-size: 12px;
      font-weight: 300;
      line-height: 14px;

      &:first-letter {
        text-transform: capitalize;
      }

      &_gray {
        color: $color-gray;
        text-transform: uppercase;
      }

      &_bold {
        font-weight: 500;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Notifications/NotificationsBar/NotificationsBarMainReject.vue